import { Component, Inject, OnInit } from '@angular/core';
import { Pedido } from '../../models/pedido.model';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { PedidosService } from '../../services/pedidos.service';

@Component({
  selector: 'app-detalles-dialog',
  templateUrl: './detalles-dialog.component.html',
  styleUrls: ['./detalles-dialog.component.scss'],
})
export class DetallesDialogComponent implements OnInit {
  pedido?: Pedido;
  loading = true;

  constructor(
    public dialogRef: MatDialogRef<DetallesDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { pedidoId: number },
    private pedidosService: PedidosService,
  ) {}

  ngOnInit(): void {
    this.pedidosService.obtenerDetallePedido(this.data.pedidoId).subscribe({
      next: (pedido) => {
        this.pedido = pedido;
        this.loading = false;
      },
      error: () => {
        this.loading = false;
      },
    });
  }
}
